import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { Bar, Messages } from './components/coninfo'

export const ConinfoMessages = () => {
  const { data } = useSelector((state) => state?.coninfoMessages)
  return (
    <Box>
      <Messages data={data} />
    </Box>
  )
}

export const ConinfoPhotos = () => {
  return (
    <Box>
    </Box>
  )
}

export const ConinfoBar = () => {
  const { data } = useSelector((state) => state?.coninfoBar)

  return (
    <Box>
      <Bar data={data} />
    </Box>
  )
}
